import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export interface SmartSuggestionIconProps {
  size?: number | string
  color?: string
}

export const SmartSuggestionIcon: FunctionComponent<SmartSuggestionIconProps> = ({ size = 24, color }) => {
  const { colors } = useTheme()
  return (
    <Svg testID={tID('SmartSuggestionIcon')} width={size} height={size} viewBox='0 0 24 24' fill='none'>
      <Path
        d='M6.077 17L4.373 18.7037C4.1205 18.9564 3.8285 19.0145 3.497 18.878C3.16567 18.7413 3 18.4929 3 18.1327V4.6155C3 4.15517 3.15417 3.77083 3.4625 3.4625C3.77083 3.15417 4.15517 3 4.6155 3H19.3845C19.8448 3 20.2292 3.15417 20.5375 3.4625C20.8458 3.77083 21 4.15517 21 4.6155V15.3845C21 15.8448 20.8458 16.2292 20.5375 16.5375C20.2292 16.8458 19.8448 17 19.3845 17H6.077ZM5.65 16H19.3845C19.5385 16 19.6796 15.9359 19.8078 15.8077C19.9359 15.6796 20 15.5385 20 15.3845V4.6155C20 4.4615 19.9359 4.32042 19.8078 4.19225C19.6796 4.06408 19.5385 4 19.3845 4H4.6155C4.4615 4 4.32042 4.06408 4.19225 4.19225C4.06408 4.32042 4 4.4615 4 4.6155V17.6442L5.65 16Z'
        fill={color ?? colors.iconDefault}
      />
      <Path
        d='M12.0489 14.3146C11.8253 14.3146 11.6398 14.1292 11.6398 13.9055C11.6398 12.0074 10.0362 10.4092 8.14347 10.4092C7.91983 10.4092 7.73438 10.2237 7.73438 10.0001C7.73438 9.77646 7.91983 9.591 8.14347 9.591C10.0416 9.591 11.6398 7.98737 11.6398 6.09464C11.6398 5.871 11.8253 5.68555 12.0489 5.68555C12.2726 5.68555 12.458 5.871 12.458 6.09464C12.458 7.99282 14.0616 9.591 15.9544 9.591C16.178 9.591 16.3635 9.77646 16.3635 10.0001C16.3635 10.2237 16.178 10.4092 15.9544 10.4092C14.0562 10.4092 12.458 12.0128 12.458 13.9055C12.458 14.1292 12.2726 14.3146 12.0489 14.3146Z'
        fill={color ?? colors.iconDefault}
      />
    </Svg>
  )
}
